import { render, staticRenderFns } from "./CollectionFieldModal.vue?vue&type=template&id=65ba7bb5&scoped=true"
import script from "./CollectionFieldModal.vue?vue&type=script&lang=js"
export * from "./CollectionFieldModal.vue?vue&type=script&lang=js"
import style0 from "./CollectionFieldModal.vue?vue&type=style&index=0&id=65ba7bb5&prod&lang=scss&scoped=true"
import style1 from "./CollectionFieldModal.vue?vue&type=style&index=1&id=65ba7bb5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ba7bb5",
  null
  
)

export default component.exports